<template>
  <div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Módosítás'"
      placement="top"
      v-can="'data.servicecategory.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateServiceCategory"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'data.servicecategory.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteServiceCategory"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>
<script>
  export default {
    props: ['serviceCategory'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },
    methods: {
      async deleteServiceCategory() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('serviceCategory/delete', this.serviceCategory.id);
          this.$store.dispatch('serviceCategory/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateServiceCategory() {
        this.$router.push('/data/services/categories/update/' + this.serviceCategory.id);
      }
    }
  };
</script>
